<template>
	<div>
		<headinfo></headinfo>
		<div class="mains" v-if="info">
			<div class="title_box">
				<div class="title">{{info.title}}</div>
				<div class="time">发布时间:{{info.publishTime}}</div>
			</div>
			<div class="content" v-html="info.content"></div>
		</div>
		<bottominfo></bottominfo>
	</div>
</template>

<script>
	import headinfo from '../components/headinfo.vue'
	import bottominfo from '../components/bottominfo.vue'
	import {getDetails} from '../api/index.js'
	export default {
		name: "Bossspeak",
		components: {
			headinfo,
			bottominfo,
		},
		metaInfo: {
			title: '动态详情-邯郸市诚信公证处',
			meta: [{
				name: 'keyWords',
				content: '动态详情'
			}],
		},
		data() {
			return {
				query:{},
				info:null,
			}
		},
		created() {
			this.query = this.$route.params
			this.getd();
		},
		methods:{
			getd(){
				getDetails(this.query).then(res=>{
					this.info = res.data
				})
			}
		}
	}
</script>

<style scoped>
	.mains{
		padding: 50px 25%;
		background-color: #FFFFFF;
	}
	.title_box{
		width: 100%;
		text-align: center;
	}
	.title{
		font-size: 32px;
	}
	.time{
		margin: 20px;
		font-size: 16px;
		color: #949696;
	}
	.content >>> img{
		width: 100%;
		height: 100%;
		margin-top: 10px;
		margin-bottom: 10px;
	}
	.content >>> p{
		line-height: 30px;
	}
</style>
